export default "/images/CodeOfConduct.webp?92c23dca51eeb6e3f11bb2f00bc1b146";